
    /*!
    * Copyright (c) Microsoft Corporation.
    * All rights reserved. See LICENSE in the project root for license information.
    * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
    * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
    */
    import {
        AsyncResult,
        callActionOrExecute,
        DataServiceQuery,
        IContext,
        IDataServiceRequest,
        IQueryResultSettings,
        // @ts-ignore -- Unused import
        NullResult
    } from '@msdyn365-commerce/retail-proxy';
    // @ts-ignore -- Unused import
    import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
    // @ts-ignore -- Unused import
    import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
    import * as DataServiceEntities from './DataServiceEntities.g';

    

        // @ts-ignore
        function memxWarrantyQuery(id?: number): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("MemxWarranty", "WarrantyType", DataServiceEntities.WarrantyTypeExtensionClass, key);
        }

        
    export function createGetWarrantyIconsInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = memxWarrantyQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetWarrantyIcons', true, DataServiceEntities.WarrantyIconExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IWarrantyIcon'}, { });
    }

    
    export function getWarrantyIconsAsync(context: IContext): AsyncResult<DataServiceEntities.IWarrantyIcon[]> {
    const request = createGetWarrantyIconsInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IWarrantyIcon[]>(request, context.callerContext);
    }
  
    export function createUpdateWarrantySelectionsInput(cart: Entities.Cart, lineSelections: DataServiceEntities.IWarrantyLineSelection[]): IDataServiceRequest {
    const query = memxWarrantyQuery();
    return query.createDataServiceRequestForOperation('UpdateWarrantySelections', true, EntityClasses.CartClass, 'false', {bypassCache: 'get', returnEntity: 'Entities.Cart'}, {cart: cart, lineSelections: lineSelections });
    }

    
    export function updateWarrantySelectionsAsync(context: IContext, cart: Entities.Cart, lineSelections: DataServiceEntities.IWarrantyLineSelection[]): AsyncResult<Entities.Cart> {
    const request = createUpdateWarrantySelectionsInput(cart, lineSelections);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
    }
  
    export function createGetProductWarrantiesInput(queryResultSettings: IQueryResultSettings, productIds: number[]): IDataServiceRequest {
    const query = memxWarrantyQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetProductWarranties', true, DataServiceEntities.ProductWarrantiesExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IProductWarranties'}, {productIds: productIds });
    }

    
    export function getProductWarrantiesAsync(context: IContext, productIds: number[]): AsyncResult<DataServiceEntities.IProductWarranties[]> {
    const request = createGetProductWarrantiesInput(
      context.queryResultSettings || {}, productIds);
    return callActionOrExecute<DataServiceEntities.IProductWarranties[]>(request, context.callerContext);
    }
  
    export function createGetCustomerWarrantyPoliciesInput(queryResultSettings: IQueryResultSettings, pageSize: number, skip: number, accountNumber: string, getDescription: boolean): IDataServiceRequest {
    const query = memxWarrantyQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetCustomerWarrantyPolicies', true, DataServiceEntities.WarrantyPolicyExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IWarrantyPolicy'}, {pageSize: pageSize, skip: skip, accountNumber: accountNumber, getDescription: getDescription });
    }

    
    export function getCustomerWarrantyPoliciesAsync(context: IContext, pageSize: number, skip: number, accountNumber: string, getDescription: boolean): AsyncResult<DataServiceEntities.IWarrantyPolicy[]> {
    const request = createGetCustomerWarrantyPoliciesInput(
      context.queryResultSettings || {}, pageSize, skip, accountNumber, getDescription);
    return callActionOrExecute<DataServiceEntities.IWarrantyPolicy[]>(request, context.callerContext);
    }
  
    export function createGetProductDefaultVariantsInput(queryResultSettings: IQueryResultSettings, productIds: number[]): IDataServiceRequest {
    const query = memxWarrantyQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetProductDefaultVariants', true, DataServiceEntities.ProductDefaultVariantExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IProductDefaultVariant'}, {productIds: productIds });
    }

    
    export function getProductDefaultVariantsAsync(context: IContext, productIds: number[]): AsyncResult<DataServiceEntities.IProductDefaultVariant[]> {
    const request = createGetProductDefaultVariantsInput(
      context.queryResultSettings || {}, productIds);
    return callActionOrExecute<DataServiceEntities.IProductDefaultVariant[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function memxShippingQuery(id?: number): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("MemxShipping", "ShippingObject", DataServiceEntities.ShippingObjectExtensionClass, key);
        }

        
    export function createGetShippingOptionsInput(queryResultSettings: IQueryResultSettings, cartId: string): IDataServiceRequest {
    const query = memxShippingQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetShippingOptions', true, DataServiceEntities.RateEstimationExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IRateEstimation'}, {cartId: cartId });
    }

    
    export function getShippingOptionsAsync(context: IContext, cartId: string): AsyncResult<DataServiceEntities.IRateEstimation[]> {
    const request = createGetShippingOptionsInput(
      context.queryResultSettings || {}, cartId);
    return callActionOrExecute<DataServiceEntities.IRateEstimation[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function mEMXServiceQuery(serviceId?: string): DataServiceQuery {
        const key = (serviceId) ? { ServiceId: serviceId } :null;
        return new DataServiceQuery("MEMXService", "ServiceItemInfo", DataServiceEntities.ServiceItemInfoExtensionClass, key);
        }

        
    export function createGetAuditLogInfoInput(queryResultSettings: IQueryResultSettings, salesId: string): IDataServiceRequest {
    const query = mEMXServiceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAuditLogInfo', true, DataServiceEntities.AuditLogEntryExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IAuditLogEntry'}, {salesId: salesId });
    }

    
    export function getAuditLogInfoAsync(context: IContext, salesId: string): AsyncResult<DataServiceEntities.IAuditLogEntry[]> {
    const request = createGetAuditLogInfoInput(
      context.queryResultSettings || {}, salesId);
    return callActionOrExecute<DataServiceEntities.IAuditLogEntry[]>(request, context.callerContext);
    }
  
    export function createUpdateAuditLogInfoInput(salesId: string, auditLogList: DataServiceEntities.IAuditLogEntry[]): IDataServiceRequest {
    const query = mEMXServiceQuery();
    return query.createDataServiceRequestForOperation('UpdateAuditLogInfo', true, '', 'false', {bypassCache: 'get', returnEntity: ''}, {salesId: salesId, auditLogList: auditLogList });
    }

    
    export function updateAuditLogInfoAsync(context: IContext, salesId: string, auditLogList: DataServiceEntities.IAuditLogEntry[]): AsyncResult<boolean> {
    const request = createUpdateAuditLogInfoInput(salesId, auditLogList);
    return callActionOrExecute<boolean>(request, context.callerContext);
    }
  

        // @ts-ignore
        function channelDataQuery(recordId?: number): DataServiceQuery {
        const key = (recordId) ? { RecordId: recordId } :null;
        return new DataServiceQuery("ChannelData", "MMX_RetailParameters", DataServiceEntities.MMX_RetailParametersExtensionClass, key);
        }

        
    export function createGetMMX_RetailParametersInput(): IDataServiceRequest {
    const query = channelDataQuery();
    return query.createDataServiceRequestForOperation('GetMMX_RetailParameters', true, DataServiceEntities.MMX_RetailParametersExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IMMX_RetailParameters'}, { });
    }

    
    export function getMMX_RetailParametersAsync(context: IContext): AsyncResult<DataServiceEntities.IMMX_RetailParameters> {
    const request = createGetMMX_RetailParametersInput();
    return callActionOrExecute<DataServiceEntities.IMMX_RetailParameters>(request, context.callerContext);
    }
  
    export function createGetReturnReasonCodesInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = channelDataQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetReturnReasonCodes', true, EntityClasses.ReasonCodeClass, 'true', {bypassCache: 'none', returnEntity: 'Entities.ReasonCode'}, { });
    }

    
    export function getReturnReasonCodesAsync(context: IContext): AsyncResult<Entities.ReasonCode[]> {
    const request = createGetReturnReasonCodesInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<Entities.ReasonCode[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function memxCoreQuery(id?: number): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("MemxCore", "MemxCoreType", DataServiceEntities.MemxCoreTypeExtensionClass, key);
        }

        
    export function createUpdateCartLinesInput(cartId: string, cartLine: Entities.CartLine[], cartVersion: number): IDataServiceRequest {
    const query = memxCoreQuery();
    return query.createDataServiceRequestForOperation('UpdateCartLines', true, EntityClasses.CartClass, 'false', {bypassCache: 'get', returnEntity: 'Entities.Cart'}, {cartId: cartId, cartLine: cartLine, cartVersion: cartVersion });
    }

    
    export function updateCartLinesAsync(context: IContext, cartId: string, cartLine: Entities.CartLine[], cartVersion: number): AsyncResult<Entities.Cart> {
    const request = createUpdateCartLinesInput(cartId, cartLine, cartVersion);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
    }
  

        // @ts-ignore
        function memxCommerceQuery(id?: number): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("MemxCommerce", "MemxCommerceType", DataServiceEntities.MemxCommerceTypeExtensionClass, key);
        }

        
    export function createGetProductCostsInput(queryResultSettings: IQueryResultSettings, productIds: number[]): IDataServiceRequest {
    const query = memxCommerceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetProductCosts', true, DataServiceEntities.ProductCostExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IProductCost'}, {productIds: productIds });
    }

    
    export function getProductCostsAsync(context: IContext, productIds: number[]): AsyncResult<DataServiceEntities.IProductCost[]> {
    const request = createGetProductCostsInput(
      context.queryResultSettings || {}, productIds);
    return callActionOrExecute<DataServiceEntities.IProductCost[]>(request, context.callerContext);
    }
  
    export function createGetApprovedCompetitorsInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = memxCommerceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetApprovedCompetitors', true, DataServiceEntities.ApprovedCompetitorExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IApprovedCompetitor'}, { });
    }

    
    export function getApprovedCompetitorsAsync(context: IContext): AsyncResult<DataServiceEntities.IApprovedCompetitor[]> {
    const request = createGetApprovedCompetitorsInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IApprovedCompetitor[]>(request, context.callerContext);
    }
  
    export function createSetPriceBeatOnCartLineInput(cartId: string, cartLine: Entities.CartLine, competitorPrice: number, competitorUrl: string, competitorPartNum: string, competitorName: string): IDataServiceRequest {
    const query = memxCommerceQuery();
    return query.createDataServiceRequestForOperation('SetPriceBeatOnCartLine', true, EntityClasses.CartClass, 'false', {bypassCache: 'get', returnEntity: 'Entities.Cart'}, {cartId: cartId, cartLine: cartLine, competitorPrice: competitorPrice, competitorUrl: competitorUrl, competitorPartNum: competitorPartNum, competitorName: competitorName });
    }

    
    export function setPriceBeatOnCartLineAsync(context: IContext, cartId: string, cartLine: Entities.CartLine, competitorPrice: number, competitorUrl: string, competitorPartNum: string, competitorName: string): AsyncResult<Entities.Cart> {
    const request = createSetPriceBeatOnCartLineInput(cartId, cartLine, competitorPrice, competitorUrl, competitorPartNum, competitorName);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
    }
  

        // @ts-ignore
        function mEMXBuildsQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("MEMXBuilds", "MEMXSystemBuildDetail", DataServiceEntities.MEMXSystemBuildDetailExtensionClass, key);
        }

        
    export function createGetSystemBuildDetailInput(queryResultSettings: IQueryResultSettings, itemId: string, inventSerialId: string): IDataServiceRequest {
    const query = mEMXBuildsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetSystemBuildDetail', true, DataServiceEntities.MEMXSystemBuildDetailExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IMEMXSystemBuildDetail'}, {itemId: itemId, inventSerialId: inventSerialId });
    }

    
    export function getSystemBuildDetailAsync(context: IContext, itemId: string, inventSerialId: string): AsyncResult<DataServiceEntities.IMEMXSystemBuildDetail[]> {
    const request = createGetSystemBuildDetailInput(
      context.queryResultSettings || {}, itemId, inventSerialId);
    return callActionOrExecute<DataServiceEntities.IMEMXSystemBuildDetail[]>(request, context.callerContext);
    }
  